import ReactGA from "react-ga4";

const TRACKING_ID = "G-G12ZT0WHS3"; // 👉 เปลี่ยนเป็นของคุณ
ReactGA.initialize(TRACKING_ID);

export default ReactGA;